import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import FormBookingDatePicker from '@/components/common/forms/form-booking-datepicker/FormBookingDatePicker';
import NoData from '@/components/common/no-data/NoData';
import { Skeleton } from '@/components/ui/skeleton';
import useServicesAvailability from '@/hooks/queries/services/useServicesAvailability';
import useCalendarPaginateNavigation from '@/hooks/useCalendarPaginateNavigation';
import { useRootStore } from '@/providers/root-store-provider';
import { TOrganizationFAQ } from '@/services/api/organization-api';

interface ChooseDateTimeStepProps {
  organization: TOrganizationFAQ;
  landing?: boolean;
}

const ChooseDateTimeStep: React.FC<ChooseDateTimeStepProps> = ({
  organization,
  landing
}) => {
  const stepServicesData = useRootStore((store) => store.stepServicesData);
  const calendarPaginateNavigation = useCalendarPaginateNavigation();
  const { month, year } = calendarPaginateNavigation;
  const {
    data: availableDates,
    isError,
    isPending
  } = useServicesAvailability({
    serviceId: stepServicesData?.service?.id,
    participants: stepServicesData?.participants,
    month,
    year
  });

  if (isPending) {
    return <Skeleton className="h-96 w-full" />;
  }
  if (!availableDates) {
    return <NoData />;
  }
  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <FormBookingDatePicker
      availableDates={availableDates}
      organization={organization}
      calendarPaginateNavigation={calendarPaginateNavigation}
      landing={landing}
    />
  );
};

export default ChooseDateTimeStep;
